export enum FiltroProdutos {
    Todos = 0,
    Codigo = 1,
    Descricao = 2,
    NomeGrupo = 3
}
